var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "information-line",
    clipPath: "url(#clip0_2172_823)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.9997 25.6668C7.55618 25.6668 2.33301 20.4437 2.33301 14.0002C2.33301 7.55666 7.55618 2.3335 13.9997 2.3335C20.4432 2.3335 25.6663 7.55666 25.6663 14.0002C25.6663 20.4437 20.4432 25.6668 13.9997 25.6668ZM13.9997 23.3335C16.475 23.3335 18.849 22.3502 20.5993 20.5998C22.3497 18.8495 23.333 16.4755 23.333 14.0002C23.333 11.5248 22.3497 9.15084 20.5993 7.4005C18.849 5.65016 16.475 4.66683 13.9997 4.66683C11.5243 4.66683 9.15035 5.65016 7.40001 7.4005C5.64967 9.15084 4.66634 11.5248 4.66634 14.0002C4.66634 16.4755 5.64967 18.8495 7.40001 20.5998C9.15035 22.3502 11.5243 23.3335 13.9997 23.3335ZM12.833 8.16683H15.1663V10.5002H12.833V8.16683ZM12.833 12.8335H15.1663V19.8335H12.833V12.8335Z",
    fill: "#94A3B8"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2172_823"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapInfo);
export default __webpack_public_path__ + "static/media/map-info.30c128ff8264a33a9cae9e2afa41ee19.svg";
export { ForwardRef as ReactComponent };